import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from "react-i18next";
import en from './locales/en.json';
import pt from './locales/pt-BR.json';


const options = {
  detection: {
    order: ['htmlTag'],
  },

  resources: {
    "pt-BR": {
      common: pt["pt-BR"]
    },
    en: {
      common: en.en,
    },
  },

  fallbackLng: 'en',

  ns: ['common'],

  defaultNS: 'common',
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(options)

export default i18n;
